import type { RegisteredComponent } from "@builder.io/sdk-react";

/**
 * Builder inputs for `ContactUsForm`. Nothing is required: dropped onto a page
 * as-is, the block is the complete live form with production copy. Copy fields
 * have NO `defaultValue` on purpose — blank means "the live SFRA string", so a
 * later copy fix in code reaches every page that never overrode it.
 *
 * Fields, labels, the Subject list and the validation copy are deliberately NOT
 * inputs: the Subject value is the support inbox's routing key and the field
 * set is the email template's contract.
 */
export const contactUsFormInputs = [
  {
    name: "submitLabel",
    friendlyName: "Button label",
    type: "text",
    helperText: 'Empty: "Submit".',
  },
  {
    name: "successMessage",
    type: "text",
    helperText:
      'Shown under the button after a send. Empty: "Sent! A Customer service representative will reach out to you shortly."',
  },
  {
    name: "failureMessage",
    type: "text",
    helperText:
      "Shown when a send fails; the shopper's entries are kept. Empty: \"Due to some difficulties we couldn't process your request. Please try again.\"",
  },
  {
    name: "editorState",
    friendlyName: "Editor preview state",
    type: "text",
    enum: [
      { label: "Empty form", value: "ready" },
      { label: "Submitted with blank fields (errors)", value: "errors" },
      { label: "Sending", value: "submitting" },
      { label: "After a successful send", value: "success" },
      { label: "After a failed send", value: "failure" },
    ],
    defaultValue: "ready",
    advanced: true,
    helperText:
      "Only affects the Visual Editor and previews — nothing is ever sent from them. Live pages always behave normally.",
  },
] satisfies NonNullable<RegisteredComponent["inputs"]>;
